import {
    DocumentViewer,
    ProviderDocumentUrl,
    ProviderInstitutionalClaim,
    ProviderNynf3Claim,
    ProviderPayerSubscriber,
    ProviderProfessionalClaim,
    ProviderSubscriberPatient,
    Spinner,
} from '@enter/core';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useContext, useEffect, useState } from 'react';
import { DialogContext } from 'services';
import { RootStore } from 'stores';
import { ClaimService } from 'stores/claim.service';
import { ClaimTimelineStyles as S } from '@enter/core';

interface IClaimDetailProps {
    claimPind: ProviderProfessionalClaim | ProviderInstitutionalClaim | ProviderNynf3Claim;
    primaryPayerSubscriber: ProviderPayerSubscriber | undefined;
    primarySubscriberPatient: ProviderSubscriberPatient | undefined;
}

export const ClaimDetail: React.FunctionComponent<IClaimDetailProps> = inject('rootStore')(
    observer(
        (props: IClaimDetailProps): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');

            if (!rootStore) {
                return <></>;
            }

            const dialogContext = useContext(DialogContext);
            const { claimStore } = rootStore;
            const { claimPind, primaryPayerSubscriber, primarySubscriberPatient } = props;
            const [loading, setLoading] = useState(false);
            const [documentUrl, setDocumentUrl] = useState<ProviderDocumentUrl | undefined>();

            useEffect(() => {
                (async (): Promise<void> => {
                    if (!claimPind?.id || !primaryPayerSubscriber?.id || !primarySubscriberPatient?.id) {
                        dialogContext.showError(new Error('Can`t fetch the document'));
                        return;
                    }

                    try {
                        setLoading(true);

                        if((claimPind as ProviderInstitutionalClaim).institutionalTemplateId) {
                            const documentUrl = await ClaimService.viewCMS1450({
                                id: claimPind?.id
                            });

                            setDocumentUrl(documentUrl);
                        } else {
                            const documentUrl = await ClaimService.viewCMS1500({
                                id: claimPind?.id,
                                payerSubscriberId: primaryPayerSubscriber?.id,
                                subscriberPatientId: primarySubscriberPatient?.id,
                            });

                            setDocumentUrl(documentUrl);
                        }

                    } catch (err) {
                        dialogContext.showError(err);
                    } finally {
                        setLoading(false);
                    }
                })();
            }, [document, claimStore]);

            return (
                <S.ExpandContainer>
                    <S.ExpandTable>
                        <S.ExpandTBody>
                            {loading && (
                                <S.ExpandTR>
                                    <S.ExpandTD colSpan={2}>
                                        <Spinner />
                                    </S.ExpandTD>
                                </S.ExpandTR>
                            )}
                        </S.ExpandTBody>
                    </S.ExpandTable>
                    {documentUrl?.url && <DocumentViewer url={documentUrl.url} />}
                </S.ExpandContainer>
            );
        },
    ),
);
